import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs`, so rapid updates (e.g. keystrokes)
 * only propagate once typing pauses.
 */
export default function useDebouncedValue(value, delayMs = 350) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
}